import React, {useState} from "react";
import {Col, FormGroup, Input, Row} from "reactstrap";
import {every, isEmpty} from "lodash";
import {toast} from "react-toastify";

const INITIAL_LOCAL_STATE = {
  name: "",
  is_active: "",
  domain: "",
  website_url: "",
  privacy_policy_url: "",
  tag_line: "",
};

const MANDATORY_KEYS = ["name", "is_active", "domain", "website_url"];

function OrganizationInformation(_props, ref) {
  const [orgFormObject, setOgFormObject] = useState(INITIAL_LOCAL_STATE);
  const [submitted, setSubmitted] = useState(false);

  const checkForValidation = () => {
    const validated = every(MANDATORY_KEYS, (each) => !!orgFormObject[each]);
    setSubmitted(true);
    if (!validated) {
      toast.error("Please check required fields");
    }
    return validated;
  };

  /* ## This Imperative Handle and customizes the instance value that is exposed to parent components when using ref. Please Don't Remove this Line ## */
  React.useImperativeHandle(ref, () => {
    return {
      isValidated: () => {
        return checkForValidation();
      },
      state: orgFormObject,
    };
  });

  const onChangeHandler = (e, type) => {
    if (type === 1) {
      const {value} = e.target;
      setOgFormObject({
        ...orgFormObject,
        [e.target.name || e.target.getAttribute("name")]: value,
      });
    } else {
      setOgFormObject({
        ...orgFormObject,
        selectedDomain: e,
        root_domain: e ? e.value : "",
      });
    }
  };

  const {name, website_url, privacy_policy_url, tag_line, domain} = orgFormObject;
  return (
    <div className="pl-lg-4">
      <Row>
        <Col lg="6">
          <FormGroup>
            <label className="form-control-label" htmlFor="input-name">
              Name <span className="text-red">*</span>
            </label>
            <Input
              className="form-control-alternative"
              id="input-name"
              placeholder="Name"
              type="text"
              value={name}
              name="name"
              data-cy={"org_name"}
              invalid={isEmpty(name) && submitted}
              onChange={(e) => onChangeHandler(e, 1)}
            />
          </FormGroup>
        </Col>
        <Col lg="6">
          <FormGroup>
            <label className="form-control-label" htmlFor="input-slug">
              Domain<span className="text-red">*</span>
            </label>
            <Input
              className="form-control-alternative"
              id="input-domain"
              placeholder="example.com"
              type="text"
              value={domain}
              name="domain"
              invalid={isEmpty(domain) && submitted}
              data-cy={"domain"}
              onChange={(e) => onChangeHandler(e, 1)}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col lg="6">
          <FormGroup>
            <label className="form-control-label" htmlFor="input-web">
              Website URL<span className="text-red">*</span>
            </label>
            <Input
              className="form-control-alternative"
              id="input-web"
              placeholder="www.example.com"
              type="text"
              value={website_url}
              name="website_url"
              data-cy={"website_url"}
              invalid={isEmpty(website_url) && submitted}
              onChange={(e) => onChangeHandler(e, 1)}
            />
          </FormGroup>
        </Col>
        <Col lg="6">
          <FormGroup>
            <label className="form-control-label" htmlFor="policy-url">
              Privacy URL
            </label>
            <Input
              className="form-control-alternative"
              id="policy-url"
              placeholder="www.example.com/privacy"
              type="text"
              value={privacy_policy_url}
              data-cy={"privacy_policy_url"}
              name="privacy_policy_url"
              onChange={(e) => onChangeHandler(e, 1)}
            />
          </FormGroup>
        </Col>
        <Col lg="6">
          <FormGroup>
            <label className="form-control-label" htmlFor="tagline">
              Tag Line
            </label>
            <Input
              className="form-control-alternative"
              id="tagline"
              placeholder="IoT Rocks!"
              type="text"
              value={tag_line}
              data-cy={"tag_line"}
              name="tag_line"
              onChange={(e) => onChangeHandler(e, 1)}
            />
          </FormGroup>
        </Col>
        <Col lg="6">
          Activated <span className="text-red">*</span>
          <FormGroup check>
            <label className="form-control-label" htmlFor="activated-yes">
              <Input
                className="form-control-alternative"
                id="activated-yes"
                type="radio"
                value={true}
                name="is_active"
                data-cy={"is_active_true"}
                onChange={(e) => onChangeHandler(e, 1)}
              />
              Yes
            </label>
          </FormGroup>
          <FormGroup check>
            <label className="form-control-label" htmlFor="activated-no">
              <Input
                className="form-control-alternative"
                id="activated-no"
                type="radio"
                value={false}
                name="is_active"
                data-cy={"is_active_false"}
                onChange={(e) => onChangeHandler(e, 1)}
              />
              No
            </label>
          </FormGroup>
        </Col>
      </Row>
    </div>
  );
}

export default React.forwardRef(OrganizationInformation);
